import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  CodigoPostalDispatcher,
  codigoPostalDispatcher
} from "./codigoPostal.dispatcher";
import { CodigoPostalStore, codigoPostaltore } from "./codigoPostal.store";
import CodigoPostalComponent from "../../components/codigoPostal";

interface Props extends CodigoPostalStore, CodigoPostalDispatcher {}
interface State {}

@ReduxConnect(codigoPostaltore, codigoPostalDispatcher)
export default class CodigoPostalContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Codigo Postal" />
          <CodigoPostalComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
